// Multisucursal — scope de eventos de socket por comercio (F0).
//
// En multi-sucursal el panel recibe eventos (pagos, estatus, repartidor) de TODAS las sucursales
// de la cuenta vía `panel_<accountId>`. Un evento que NO es del comercio activo no debe mutar el
// estado local (p.ej. crear una "orden fantasma" de otra sucursal en el Kanban actual, GAP-3).
//
// Regla: el evento es del comercio actual si no trae `commerceId` (mono-sucursal / legacy) o si
// coincide con el `id_comercio` activo.
//
// - eventCommerceId: `commerceId` del evento (puede venir ausente).
// - currentCommerceId: `localStorage.id_commerce` activo (puede ser null durante transiciones).
// - retorna `true` si el evento corresponde al comercio activo y puede procesarse.
export const isEventForCurrentCommerce = (
  eventCommerceId: string | undefined | null,
  currentCommerceId: string | null,
): boolean => {
  if (!eventCommerceId) return true;
  return eventCommerceId === currentCommerceId;
};

export default isEventForCurrentCommerce;
